import { EventInfoSecondary } from '@/app_components/Conferences/EventInfoSecondary';
import { Image } from '@/app_components/common/Image';
import type { EventsListEvent } from '@/app_lib/types/Conferences';
import { cn } from '@/app_lib/utils/utils';

export const EventTile = ({ event, isPast }: { event: EventsListEvent; isPast: boolean }) => (
  <div
    className={cn(
      'h-full w-full min-w-0 max-lg:aspect-square lg:aspect-[4/5] relative isolate group p-xs xl:p-sm rounded-sm ring ring-secondary',
      isPast ? 'bg-secondary' : 'hover:[&_*]:text-white active:[&_*]:text-white shadow-md',
    )}
  >
    <EventInfoSecondary
      event={event}
      past={isPast}
    />
    {!isPast && (
      <>
        <Image
          alt={event.cardMedia.alt}
          className='-z-2 rounded-sm object-cover absolute top-0 left-0 w-full h-full opacity-0 group-hover:opacity-100 group-active:opacity-100 transition-opacity duration-300 ease-in-out'
          height={450}
          src={event.cardMedia.url}
          width={300}
        />
        <div className='absolute rounded-sm -z-1 top-0 left-0 w-full h-full bg-black opacity-0 group-hover:opacity-50 group-active:opacity-50 transition-opacity duration-300 ease-in-out' />
      </>
    )}
  </div>
);
